import { Component } from '@angular/core';
import {InfoMessageService} from '../../services/infomessage/infomessage.service';
import {RouterLink} from '@angular/router';
import {AuthenticationService} from '../../services/authentication/authentication.service';
import {UserModel} from '../../models/user/user.model';

@Component({
  selector: 'app-home',
    imports: [
        RouterLink
    ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.sass'
})
export class HomeComponent {
    user! : UserModel
    constructor(
        private authenticationService: AuthenticationService
    ) {
        this.user = this.authenticationService.getUser();
        this.authenticationService.userSubject.subscribe(user => {
            this.user = user
        })

    }

}
